import { render, staticRenderFns } from "./MobileSubmenu.vue?vue&type=template&id=dbe43940&"
import script from "./MobileSubmenu.vue?vue&type=script&lang=js&"
export * from "./MobileSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports